import { useDisclosure } from '@chakra-ui/hooks'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tag,
  TagCloseButton,
  TagLabel,
} from '@chakra-ui/react'
import React, { useMemo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { colors } from '../../../../ui-kit'
import type { FileTypeStateObject } from '../../../interfaces'
import { TextWrapper } from '../FilterText'
import FileTypeInputForm from '../InputForms/FileTypeInputForm'

interface Props {
  fileType: FileTypeStateObject
  setFileType(fileType: FileTypeStateObject): void
}

const FileTypeFilter = (props: Props): React.ReactElement => {
  const { fileType, setFileType } = props
  const { t } = useTranslation()

  const {
    isOpen: isOpenFilterForm,
    onClose: onCloseFilterForm,
    onOpen: onOpenFilterForm,
  } = useDisclosure({
    defaultIsOpen: false,
  })

  // const maxFilterWidth = useMemo<number | undefined>(
  //   () => maxWidthRef.current?.offsetWidth,
  //   [maxWidthRef],
  // )

  const filterTextComponent = useMemo(() => {
    if (fileType.value.trim() === '') {
      return (
        <TextWrapper text={t('file_type', 'File type')} textColor={colors.imagekitGray[700]} />
      )
    }
    return (
      <TextWrapper
        text={`${t('file_type', 'File type')}: ${fileType.text}`}
        textColor={colors.imagekitGray[700]}
        textFontWeight="normal"
      />
    )
  }, [fileType])

  const initialFocusRef = useRef<HTMLElement>(null)

  return (
    <Popover
      placement="bottom-start"
      initialFocusRef={initialFocusRef}
      isOpen={isOpenFilterForm}
      onClose={onCloseFilterForm}
      closeOnBlur={true}
      isLazy={true}
    >
      <PopoverTrigger>
        <Tag
          cursor="pointer"
          // maxWidth={maxFilterWidth}

          paddingY="6px"
          paddingX="8px"
          h="33px"
          borderRadius="4px"
          borderWidth="1px"
          borderColor={fileType.value ? '#cddcf7' : '#e1e4eb'}
          _hover={{ bgColor: colors.appBlueyGrey }}
          bgColor={fileType.value ? '#f3f8ff' : 'unset'}
          onClick={() => {
            onOpenFilterForm()
          }}
        >
          <TagLabel color={colors.appSlate} fontWeight="normal">
            {filterTextComponent}
          </TagLabel>
          {fileType.value !== '' ? (
            <TagCloseButton
              onClick={e => {
                e.stopPropagation()
                setFileType({ text: '', value: '' })
              }}
            />
          ) : (
            <></>
          )}
        </Tag>
      </PopoverTrigger>
      <PopoverContent
        _highlighted={{
          border: 'solid 0.5px #cdd5d',
          borderRadius: '0px',
        }}
        _focus={{ border: 'solid 0.5px #cdd5d', borderRadius: '0px' }}
        _focusVisible={{
          border: 'solid 0.5px #cdd5d',
          borderRadius: '0px',
          outline: 'none',
        }}
        _focusWithin={{
          border: 'solid 0.5px #cdd5d',
          borderRadius: '0px',
        }}
        _active={{ border: 'solid 0.5px #cdd5d', borderRadius: '0px' }}
        borderWidth="0.5px"
        borderColor="#cdd5df"
        borderRadius="0"
        padding="0.75em"
      >
        <FileTypeInputForm fileType={fileType} setFileType={setFileType} />
      </PopoverContent>
    </Popover>
  )
}

export default FileTypeFilter
